import $ from 'jquery';
import React from 'react';
import { Link } from 'react-router-dom';

import ModalWindow from '../../component/common/ModalWindow';
import Shimmer from '../../component/common/Shimmer';
import Header from './../../component/common/Header';
import Loader from './../../component/common/Loader';
import AddComment from './../../component/etour/AddComment';
import CONSTANT from './../../constant';

import { addComment, getCommentList, getEtourDetail, getReimbursementDetail, uploadAttachment } from '../../actions/EtourAction';
import { getCookie, getDateParts, getStorage, getTimeParts } from '../../utils';

class ComponentName extends React.Component<any, any>{
     
    constructor(props: any) {
        super(props);
        this.state = {
            code: props.match.params.code,
            ud: getCookie(CONSTANT.cookie.userDetail),
            permissions: getStorage(CONSTANT.cookie.permissions),
            detail: undefined,
            reimbursementDetail: undefined,
            attachments: undefined,
            programmeDetail: undefined,
            hotelAccomdotion :undefined ,
            dailyAllowance:undefined, 
            comments: undefined,
            showAddComment: false,
            showLoader: false,
            grandTotal:undefined
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        
        document.title = CONSTANT.pageTitle.etourDetail;
        const { code } = this.state;
        getEtourDetail(code).then((res: any) => {
            if (res.error) {
                alert(res.error);
            } else {
                 
                  
                this.setState({ detail: res.result.detail,
                     programmeDetail : res.result.programmeDetail ,
                     hotelAccomdotion : res.result.hotelAccomdotion ,
                     dailyAllowance :  res.result.dailyAllowance,
                     attachments :  res.result.attachments , 
                     grandTotal: res.result.grandTotal
                     ,});
                      
                if (res.result.detail.notingCode === CONSTANT.static.noting.approved) {
                    getReimbursementDetail(code).then((res: any) => {
                        this.setState({ reimbursementDetail: res.result });
                    });
                     
                }
            }
        });

         
        getCommentList(code).then((res: any) => {
            this.setState({ comments: res.result });
        });
    }

    render() {
          const { code, detail, comments, attachments, reimbursementDetail  } = this.state;
         const { showAddComment, showLoader, ud } = this.state;
        
         const showAddCommentButton = detail && detail.pendingWith === ud.code;
 

        const showUploadReimbursmentButton = (detail && reimbursementDetail)
            && ud.code === detail.createdBy
            && detail.notingCode === CONSTANT.static.noting.approved
            && reimbursementDetail.cashDetail === null ;

        return (
            <div className="container-fluid">
                <div className="row">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                        <div className="row my-3">
                            <div className="col-md-8">
                                <h1 className="page-title">E-tour detail</h1>
                            </div>
                            <div className="col-md-4">
                                <Link to={CONSTANT.component.userETourList.url} className="btn btn-sm btn-link float-right">Go Back</Link>
                                <button onClick={this.onPrint} className="btn btn-sm btn-link float-right"><i className="fa fa-print" /> Print</button>
                            </div>
                        </div>
                        <div className="row">
                             
                            <div className="col-md-12">
                                {
                                    detail === undefined && <Shimmer />
                                }
                                {
                                    detail !== undefined && this.renderDetail()
                                }
                                {
                                    reimbursementDetail !== undefined && reimbursementDetail.cashDetail !== null && this.renderReimbursementDetail()
                                }
                                 
                                {
                                    comments !== undefined && attachments !== undefined && this.renderComments()
                                }
                                 
                            </div>
                        </div>

                    </div>
                </div>
                {
                 
                 showLoader && <Loader />
                }
                 
                  
                {
                    showAddComment && <ModalWindow
                        title="Add comment"
                        backdrop="static"
                        toggleModal={this.toggleAddComment}>
                        <AddComment
                            code={code}
                            onSubmit={this.onAddComment}
                            toggleModal={this.toggleAddComment}
                        />
                    </ModalWindow>
                      
                }
                {
                    showAddCommentButton && <div title="Add comment" className="comment-button btn btn-sm" onClick={this.toggleAddComment}>
                        Add Comment
                    </div>
                }
                {
                    showUploadReimbursmentButton && <Link className="comment-button btn btn-sm" title="Add Reimbursement detail and upload bills" style={showAddCommentButton ? { marginBottom: 50 } : {}} to={CONSTANT.component.userAddReimbursementDetail.url.replace(':code', code)}>
                        Add Reimbursement Detail
                    </Link>
                }
            </div>
        )
    }

    renderDetail = () => {
        const { detail, programmeDetail, attachments ,hotelAccomdotion  ,dailyAllowance  } = this.state;
        const startDate = getDateParts(detail.createdOn);
        const createdOn = getDateParts(detail.createdOn);
         
        let totalAmout = programmeDetail.reduce(function (accumulator: any, currentValue: any) {
            return accumulator + parseFloat(currentValue.total);
        }, 0);


        let totalHotelAccomodation = hotelAccomdotion.reduce(function (accumulator: any, currentValue: any) {
            return accumulator + parseFloat(currentValue.amountClaimed);
        }, 0);


        
        let totalDailyALlowance = dailyAllowance.reduce(function (accumulator: any, currentValue: any) {
            return accumulator + parseFloat(currentValue.amountRs);
        }, 0);



        return (
            <div className="card main-file mb-3">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12 text-center">(1)</div>
                        <div className="col-md-12 mb-3">
                            <b>Purpose: {detail.purpose}</b>
                            <div className="float-right">
                                {`${startDate.date} ${startDate.monthName} ${startDate.year}`}
                            </div>
                        </div>
                        <div className="col-md-12 mb-3 text-justify">
                            <div dangerouslySetInnerHTML={{ __html: detail.additionalComment.replace(/(?:\r\n|\r|\n)/g, '<br>') }} />
                        </div>

                        <div className="col-md-12 mb-3">
                            <hr />
                             
                            <div className="text-center">
                                Tour Programme
                            </div>

                            <table className="table table-bordered bg-light table-hover mt-3">
                                <thead>
                                    <tr className="active">
                                        <th style={{ width: '3%' }}>#</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th>From</th>
                                        <th>To</th>
                                        <th>Mode of travel</th>
                                        <th>Fare</th>
                                        <th>D.A.</th>
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                     
                                       { 
                                            
                                        programmeDetail.map(( item: any, index: number ) => {
                                            const dt = getDateParts(item.startDate);
                                            const tm = getTimeParts(item.startTime);
                                            const edt = getDateParts(item.endDate);
                                            const etm = getTimeParts(item.endTime);
                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{`${dt.date} ${dt.monthName} ${dt.year} ${tm.hour}:${tm.minute} ${tm.amOrpm}`}</td>
                                                    <td>{`${edt.date} ${edt.monthName} ${edt.year} ${etm.hour}:${etm.minute} ${etm.amOrpm}`}</td>
                                                    <td>{item.from}</td>
                                                    <td>{item.to}</td>
                                                    <td>{item.modeOfTravel}</td>
                                                    <td>{CONSTANT.static.currencySymbol} {parseFloat(item.fare).toLocaleString(CONSTANT.static.locale)}</td>
                                                    <td>{CONSTANT.static.currencySymbol} {parseFloat(item.da).toLocaleString(CONSTANT.static.locale)}</td>
                                                    <td>{CONSTANT.static.currencySymbol} {parseFloat(item.total).toLocaleString(CONSTANT.static.locale)}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                    <tr>
                                        <td colSpan={8}>Total</td>
                                        <td className="font-weight-bold">{CONSTANT.static.currencySymbol} {parseFloat(totalAmout).toLocaleString(CONSTANT.static.locale)}</td>
                                    </tr>

                                </tbody>
                               </table>

                   {/* // hotel Accomodation  */}

            <table className="table table-bordered bg-light table-hover mt-3">
                                <thead>
                                    <tr className="active">
                                        <th style={{ width: '3%' }}>   </th>
                                        <th>Class </th>
                                        <th>Station  </th>
                                        <th>Name of Hotel </th>
                                        <th>Period of Stay  </th>
                                        <th>Amount Claimed </th>
                                        <th>From</th>
                                        <th>To Date</th>
                                        <th> Remark </th>
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                     
                                    {  
                                     this.state.hotelAccomdotion.map(( item: any, index: number ) => {       
                                            return (
                                                <tr key={index}>
                                                    <td>{programmeDetail.length +index+1}</td>
                                                    <td>{item.stationClass}</td>
                                                    <td>{item.station}</td>
                                                    <td>{item.hotelName}</td>
                                                    <td>{item.periodOfStay}</td>
                                                    <td> {CONSTANT.static.currencySymbol} {item.amountClaimed}</td>
                                                    <td> {item.from} </td>
                                                    <td>{item.to}</td>
                                                    <td>{item.remark}</td>
                                                    <td> {CONSTANT.static.currencySymbol} {parseFloat(item.amountClaimed).toLocaleString(CONSTANT.static.locale)}</td>
                                                 
                                                 </tr>
                                            )
                                        })
                                    }
                                     
                                    <tr>
                                        <td colSpan={10} >Total</td>
                                        <td className="font-weight-bold">{CONSTANT.static.currencySymbol} {parseFloat(totalHotelAccomodation).toLocaleString(CONSTANT.static.locale)}</td>
                                    
                                    </tr>

                                </tbody>
                            </table>






     {/* // Daily allowance detail   */}

     <table className="table table-bordered bg-light table-hover mt-3">
                                <thead>
                                    <tr className="active">
                                        <th style={{ width: '3%' }}>   </th>
                                        <th>Class </th>
                                        <th>Station  </th>
                                        <th>D.A. Type </th>
                                        <th> D.A. in Rs </th>
                                        <th>Days </th>
                                        <th>total</th>
                                      
                                    </tr>
                                </thead>
                                <tbody>
                                     
                                    {  
                                     this.state.dailyAllowance.map(( item: any, index: number ) => {       
                                            // const sd = getDateParts(item.from);
                                            // const ed = getTimeParts(item.to);
                                             
                                            // const edt = getDateParts(item.endDate);
                                            // const etm = getTimeParts(item.endTime);

                                            return (
                                                <tr key={index}>
                                                    <td>{hotelAccomdotion.length +index+1}</td>
                                                    <td>{item.stationClass}</td>
                                                    <td>{item.station}</td>
                                                    <td>{item.noOfDas}</td>
                                                    <td> {CONSTANT.static.currencySymbol} {item.noOfDaRs}</td>
                                                    <td>{item.days}</td>
                                                    <td> {CONSTANT.static.currencySymbol} {parseFloat(item.amountRs).toLocaleString(CONSTANT.static.locale)}</td>
                                                 </tr>
                                              )
                                          })
                                       }
                                     
                                      
                                    <tr>
                                        <td colSpan={10} >Total</td>
                                        <td className="font-weight-bold">{CONSTANT.static.currencySymbol} {parseFloat(totalDailyALlowance).toLocaleString(CONSTANT.static.locale)}</td>
                                    </tr>
                                                        
                                
                            {
                                    this.state.grandTotal.length>0 && 
                                    this.state.grandTotal.map((ele:any,index:any)=>{
                                                    return (
                                                            <>
                                                                <tr>
                                                            <td colSpan={10} >Grand Total </td>
                                                            <td className="font-weight-bold">{CONSTANT.static.currencySymbol} {parseFloat(ele.totalfare).toLocaleString(CONSTANT.static.locale)}</td>
                                                                </tr>
                                                            </>
                                                        )
                                        
                                    })
                                }
                                   

                                </tbody>
                            </table>
                             
                        </div>
                        <div className="col-md-12 text-right">
                            <span className="fs-12">
                                {detail.employeeName}<br />
                                {detail.createdByDesignation}<br />
                                {`${createdOn.date} ${createdOn.monthName} ${createdOn.year} ${createdOn.hour}:${createdOn.minute}:${createdOn.seconds} ${createdOn.amOrpm}`}</span>
                        </div>
                    </div>
                </div>
                
                 
                {
                    attachments && attachments.length > 0 &&
                    <div className="card-footer no-print">
                        <div className="row">
                            <div className="col-md-12 no-print">
                                <span className="mr-3">Attachment(s)</span>
                                {
                                    attachments.filter((i: any) => i.commentCode === null).map(function (item: any, index: number) {
                                        const downloadURL = `${process.env.REACT_APP_BASE_URL}etour/${item.eTourCode}/${item.fileName}`.replace('v1/', '');
                                        return (
                                            <a href={downloadURL} target="_blank" key={index} className="badge badge-primary mr-1 p-2"><i className="fa fa-arrow-circle-o-down" /> {item.originalFileName}</a>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }

    renderReimbursementDetail = () => {
        const { reimbursementDetail } = this.state;
        const { travelFare, roadMilage, hotelAllowance, cashAllowance } = reimbursementDetail;
        return (
            <div className="card mb-3 reimbursement-detail">
                <div className="card-header">
                    Reimbursement Detail
                </div>
                <div className="card-body">
                    {this.renderTravelFare()}
                    {roadMilage.length > 0 && this.renderRoadMilage()}
                    {hotelAllowance.length > 0 && this.renderHotelAllowance()}
                    {cashAllowance.length > 0 && this.renderCashAllowance()}
                    {this.renderCashDetail()}
                </div >
            </div >
        )
    }

    renderTravelFare = () => {
        const { reimbursementDetail ,hotelAccomdotion ,dailyAllowance  } = this.state;
        const { travelFare } = reimbursementDetail;
        const bills = reimbursementDetail.bills.filter((i: any) => i.reimbursementType === CONSTANT.static.reimbursementTypeBills.travelFareBills);
        
        let totalAmout = travelFare.reduce(function (accumulator: any, currentValue: any) {
            return accumulator + parseFloat(currentValue.amount);
        }, 0);



         
        return (
            <div className="row">
                <div className="col-md-12 mb-3">
                    <b>Travel Fare</b>
                </div>
                <div className="col-md-12">
                    <table className="table table-bordered table-hover">
                        <tbody>
                            <tr className="active">
                                <th rowSpan={2} className="align-bottom" style={{ width: '3%' }}>#</th>
                                <th colSpan={2} className="text-center ">Departure</th>
                                <th colSpan={2} className="text-center">Arrival</th>
                                <th rowSpan={2} className="text-center align-bottom">Mode of Journey</th>
                                <th colSpan={2} className="text-center">Fare</th>
                                {/* <th rowSpan={2} className="text-center align-bottom">Bill(s)</th> */}
                                <th rowSpan={2} className="text-center align-bottom">Amount</th>
                            </tr>
                            <tr>
                                <th>Station</th>
                                <th>Date & Hour</th>
                                <th>Station</th>
                                <th>Date & Hour</th>
                                <th>Class</th>
                                <th>No. of Fare</th>
                            </tr>
                            {
                                travelFare.length === 0 && <tr>
                                    <td colSpan={11} className="text-center">No records found</td>
                                </tr>
                            }
                            {
                                travelFare.map((item: any, index: number) => {
                                    const depDt = getDateParts(item.depDate);
                                    const depTm = getTimeParts(item.depTime);
                                    const arrDt = getDateParts(item.arrDate);
                                    const arrTm = getTimeParts(item.arrTime);


                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.depStation}</td>
                                            <td>{`${depDt.date} ${depDt.monthName} ${depDt.year}`} {`${depTm.hour}:${depTm.minute} ${depTm.amOrpm}`}</td>
                                            <td>{item.arrStation}</td>
                                            <td>{`${arrDt.date} ${arrDt.monthName} ${arrDt.year}`} {`${arrTm.hour}:${arrTm.minute} ${arrTm.amOrpm}`}</td>
                                            <td>{item.modeOfJourney}</td>
                                            <td>{item.fareClass}</td>
                                            <td>{item.noOfFare}</td>
                                            <td>{CONSTANT.static.currencySymbol} {parseFloat(item.amount).toLocaleString(CONSTANT.static.locale)}</td>
                                        </tr>
                                    )
                                })
                            }
                            <tr>
                                <td colSpan={8}>Total</td>
                                <td colSpan={2} className="font-weight-bold">{CONSTANT.static.currencySymbol} {parseFloat(totalAmout).toLocaleString(CONSTANT.static.locale)}</td>
                            </tr>
                            {
                                bills.length > 0 && <tr><td colSpan={10}>
                                    <span className="mr-3">Download Bill(s)</span>
                                    {
                                        bills.map(function (item: any, index: number) {
                                            const downloadURL = `${process.env.REACT_APP_BASE_URL}reimbursement/${item.eTourCode}/${item.fileName}`.replace('/v1/', '/');
                                            return (
                                                <a href={downloadURL} target="_blank" key={index} className="badge badge-primary mr-1 p-2"><i className="fa fa-arrow-circle-o-down" /> {item.originalFileName}</a>
                                            )
                                        })
                                    }
                                </td></tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    // road milage section
    renderRoadMilage = () => {
        const { reimbursementDetail } = this.state;
        const { roadMilage } = reimbursementDetail;
        let totalAmout = roadMilage.reduce(function (accumulator: any, currentValue: any) {
            return accumulator + parseFloat(currentValue.amount);
        }, 0);
        const bills = reimbursementDetail.bills.filter((i: any) => i.reimbursementType === CONSTANT.static.reimbursementTypeBills.roadMilageBills);
        return (
            <div className="row">
                <div className="col-md-12 mb-3">
                    <b>Road Milage(for hired-owned conveyance)</b>
                </div>
                <div className="col-md-12">
                    <table className="table table-bordered table-hover">
                        <tbody>
                            <tr className="active">
                                <th rowSpan={2} className="align-bottom" style={{ width: '3%' }}>#</th>
                                <th colSpan={2} className="text-center">From</th>
                                <th colSpan={2} className="text-center">To</th>
                                <th rowSpan={2} className="text-center align-bottom">Mode of Conveyance</th>
                                <th rowSpan={2} className="text-center align-bottom">Total K.M.</th>
                                <th rowSpan={2} className="text-center align-bottom">Rate</th>
                                <th rowSpan={2} className="text-center align-bottom">Vehicle No.</th>
                                <th rowSpan={2} className="text-center align-bottom">Amount</th>
                            </tr>
                            
                             <tr>
                                <th>Place</th>
                                <th>Date & Hour</th>
                                <th>Place</th>
                                <th>Date & Hour</th>
                                {/* Mode of journey */}
                            </tr>
                             
                            {
                                roadMilage.length === 0 && <tr>
                                    <td colSpan={11} className="text-center">No records found</td>
                                </tr>
                            }
                             
                            {
                                roadMilage.map((item: any, index: number) => {
                                    const depDt = getDateParts(item.depDate);
                                    const depTm = getTimeParts(item.depTime);
                                    const arrDt = getDateParts(item.arrDate);
                                    const arrTm = getTimeParts(item.arrTime);

                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.depPlace}</td>
                                            <td>{`${depDt.date} ${depDt.monthName} ${depDt.year}`} {`${depTm.hour}:${depTm.minute} ${depTm.amOrpm}`}</td>
                                            <td>{item.arrPlace}</td>
                                            <td>{`${arrDt.date} ${arrDt.monthName} ${arrDt.year}`} {`${arrTm.hour}:${arrTm.minute} ${arrTm.amOrpm}`}</td>
                                            <td>{item.modeOfConveyance}</td>
                                            <td>{item.totalKM}</td>
                                            <td>{item.rate}</td>
                                            <td>{item.vehicleNumber}</td>
                                            <td>{CONSTANT.static.currencySymbol} {parseFloat(item.amount).toLocaleString(CONSTANT.static.locale)}</td>
                                        </tr>
                                    )
                                })
                            }
                            <tr>
                                <td colSpan={9}>Total</td>
                                <td colSpan={2} className="font-weight-bold">{CONSTANT.static.currencySymbol} {parseFloat(totalAmout).toLocaleString(CONSTANT.static.locale)}</td>
                            </tr>
                             
                            {
                                bills.length > 0 && <tr><td colSpan={10}>
                                    <span className="mr-3">Download Bill(s)</span>
                                    {
                                        bills.map(function (item: any, index: number) {
                                            const downloadURL = `${process.env.REACT_APP_BASE_URL}reimbursement/${item.eTourCode}/${item.fileName}`.replace('/v1/', '/');
                                            return (
                                                <a href={downloadURL} target="_blank" key={index} className="badge badge-primary mr-1 p-2"><i className="fa fa-arrow-circle-o-down" /> {item.originalFileName}</a>
                                            )
                                        })
                                    }
                                </td></tr>
                            }
                        </tbody>
                    </table>

                </div>
            </div>
        )
    }

    // hotel allowance section
    renderHotelAllowance = () => {
        const { reimbursementDetail } = this.state;
        const { hotelAllowance } = reimbursementDetail;
        let totalAmout = hotelAllowance.reduce(function (accumulator: any, currentValue: any) {
            return accumulator + parseFloat(currentValue.amount);
        }, 0);
        const bills = reimbursementDetail.bills.filter((i: any) => i.reimbursementType === CONSTANT.static.reimbursementTypeBills.hotelAllowanceBills);

        return (
            <div className="row">
                <div className="col-md-12 mb-3">
                    <b>Hotel/Loading Allowance</b>
                </div>
                <div className="col-md-12">
                    <table className="table table-bordered table-hover">
                        <tbody>
                            <tr className="active">
                                <th rowSpan={2} className="align-bottom" style={{ width: '3%' }}>#</th>
                                <th rowSpan={2} className="text-center align-bottom">Place of Stay</th>
                                <th colSpan={2} className="text-center">Duration of stay</th>
                                <th rowSpan={2} className="text-center align-bottom">No. of days</th>
                                <th rowSpan={2} className="text-center align-bottom">No. of D.A.</th>
                                <th rowSpan={2} className="text-center align-bottom">Rate</th>
                                <th rowSpan={2} className="text-center align-bottom">Amount</th>
                            </tr>
                            <tr>
                                <th>From</th>
                                <th>To</th>
                            </tr>
                            {
                                hotelAllowance.length === 0 && <tr>
                                    <td colSpan={10} className="text-center">No records found</td>
                                </tr>
                            }
                            {
                                hotelAllowance.map((item: any, index: number) => {
                                    const fdt = getDateParts(item.fromDate);
                                    const tdt = getDateParts(item.toDate);

                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.place}</td>
                                            <td>{`${fdt.date} ${fdt.monthName} ${fdt.year}`}</td>
                                            <td>{`${tdt.date} ${tdt.monthName} ${tdt.year}`}</td>
                                            <td>{item.noOfDays}</td>
                                            <td>{item.noOfDA}</td>
                                            <td>{item.rate}</td>
                                            <td>{CONSTANT.static.currencySymbol} {parseFloat(item.amount).toLocaleString(CONSTANT.static.locale)}</td>
                                        </tr>
                                    )
                                })
                            }
                            <tr>
                                <td colSpan={7}>Total</td>
                                <td colSpan={2} className="font-weight-bold">{CONSTANT.static.currencySymbol} {parseFloat(totalAmout).toLocaleString(CONSTANT.static.locale)}</td>
                            </tr>
                             
                            {
                                bills.length > 0 && <tr><td colSpan={9}>
                                    <span className="mr-3">Download Bill(s)</span>
                                    {
                                        bills.map(function (item: any, index: number) {
                                            const downloadURL = `${process.env.REACT_APP_BASE_URL}reimbursement/${item.eTourCode}/${item.fileName}`.replace('/v1/', '/');
                                            return (
                                                <a href={downloadURL} target="_blank" key={index} className="badge badge-primary mr-1 p-2"><i className="fa fa-arrow-circle-o-down" /> {item.originalFileName}</a>
                                            )
                                        })
                                    }
                                     
                                </td></tr>
                            }

                             
                        </tbody>
                    </table>
                </div>
            </div>

        )
    }

    // cash allowance section
    renderCashAllowance = () => {
         
        const { reimbursementDetail } = this.state;
        const { cashAllowance } = reimbursementDetail;

        let totalAmout = cashAllowance.reduce(function (accumulator: any, currentValue: any) {
            return accumulator + parseFloat(currentValue.amount);
        }, 0);
        const bills = reimbursementDetail.bills.filter((i: any) => i.reimbursementType === CONSTANT.static.reimbursementTypeBills.cashAllowanceBills);
        return (
            <div className="row">
                <div className="col-md-12 mb-3">
                    <b>Cash Allowance</b>
                </div>
                <div className="col-md-12">
                    <table className="table table-bordered table-hover">
                        <tbody>
                            <tr className="active">
                                <th rowSpan={2} className="align-bottom" style={{ width: '3%' }}>#</th>
                                <th rowSpan={2} className="text-center align-bottom">Place of Stay</th>
                                <th colSpan={2} className="text-center">Duration of stay</th>
                                <th rowSpan={2} className="text-center align-bottom">No. of days</th>
                                <th rowSpan={2} className="text-center align-bottom">No. of D.A.</th>
                                <th rowSpan={2} className="text-center align-bottom">Rate</th>
                                <th rowSpan={2} className="text-center align-bottom">Amount</th>
                            </tr>
                            <tr>
                                <th>From</th>
                                <th>To</th>
                            </tr>
                            {
                                cashAllowance.length === 0 && <tr>
                                    <td colSpan={10} className="text-center">No records found</td>
                                </tr>
                            }
                            {
                                cashAllowance.map((item: any, index: number) => {
                                    const fdt = getDateParts(item.fromDate);
                                    const tdt = getDateParts(item.toDate);

                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.place}</td>
                                            <td>{`${fdt.date} ${fdt.monthName} ${fdt.year}`}</td>
                                            <td>{`${tdt.date} ${tdt.monthName} ${tdt.year}`}</td>
                                            <td>{item.noOfDays}</td>
                                            <td>{item.noOfDA}</td>
                                            <td>{item.rate}</td>
                                            <td>{CONSTANT.static.currencySymbol} {parseFloat(item.amount).toLocaleString(CONSTANT.static.locale)}</td>
                                        </tr>
                                    )
                                })
                            }
                            <tr>
                                <td colSpan={7}>Total</td>
                                <td colSpan={2} className="font-weight-bold">{CONSTANT.static.currencySymbol} {parseFloat(totalAmout).toLocaleString(CONSTANT.static.locale)}</td>
                            </tr>
                            {
                                bills.length > 0 && <tr><td colSpan={9}>
                                    <span className="mr-3">Download Bill(s)</span>
                                    {
                                        bills.map(function (item: any, index: number) {
                                            const downloadURL = `${process.env.REACT_APP_BASE_URL}reimbursement/${item.eTourCode}/${item.fileName}`.replace('/v1/', '/');
                                            return (
                                                <a href={downloadURL} target="_blank" key={index} className="badge badge-primary mr-1 p-2"><i className="fa fa-arrow-circle-o-down" /> {item.originalFileName}</a>
                                            )
                                        })
                                    }
                                </td></tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    // cash detail section
    renderCashDetail = () => {
        const { advance, used, balance } = this.state.reimbursementDetail.cashDetail;
        const { travelFare, roadMilage, hotelAllowance, cashAllowance } = this.state.reimbursementDetail;
        let tfTotal = travelFare.reduce(function (accumulator: any, currentValue: any) {
            return accumulator + parseFloat(currentValue.amount);
        }, 0);
        let rmTotal = roadMilage.reduce(function (accumulator: any, currentValue: any) {
            return accumulator + parseFloat(currentValue.amount);
        }, 0);
        let haTotal = hotelAllowance.reduce(function (accumulator: any, currentValue: any) {
            return accumulator + parseFloat(currentValue.amount);
        }, 0);
        let caTotal = cashAllowance.reduce(function (accumulator: any, currentValue: any) {
            return accumulator + parseFloat(currentValue.amount);
        }, 0);
        const calculatedTotal = tfTotal + rmTotal + haTotal + caTotal;
        const calculatedBalance = parseFloat(advance.value) - calculatedTotal;

        return (
            <div className="row mt-3">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-4 text-center">
                                    <h5>Advance taken</h5>
                                    {CONSTANT.static.currencySymbol} {parseFloat(advance).toLocaleString(CONSTANT.static.locale)}
                                </div>
                                <div className="col-md-4 text-center">
                                    <h5>Amount used </h5>
                                    {CONSTANT.static.currencySymbol} {parseFloat(used).toLocaleString(CONSTANT.static.locale)}
                                </div>
                                <div className="col-md-4 text-center">
                                    <h5>Balance</h5>
                                    {CONSTANT.static.currencySymbol} {parseFloat(balance).toLocaleString(CONSTANT.static.locale)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderComments = () => {
        const { comments, attachments, detail, ud, permissions } = this.state;

        const canReadComments =
            detail.pendingWith === ud.code
            || detail.modifiedBy === ud.code
            || permissions.indexOf(CONSTANT.static.permissions.fileAdminAccess) > -1;

        const renderComments = comments.map(function (item: any, index: number) {
            const commentDt = getDateParts(item.createdOn);
            const commAttachment = attachments.filter((i: any) => i.commentCode === item.code);
            return (
                <div className="card comment-file mb-3" key={index} id={`comment-${item.code}`}>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <div>
                                    <span>({index + 2})</span>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <strong>{item.notingName}</strong>
                            </div>
                            {
                                item.comment && <div className="col-md-12 text-justify">
                                    <div dangerouslySetInnerHTML={{ __html: item.comment.replace(/(?:\r\n|\r|\n)/g, '<br>') }} />
                                </div>
                            }
                        </div>
                        <div className="row mt-3">
                            <div className="col-md-6">
                            </div>
                            <div className="col-md-6 text-right">
                                <span className="fs-12">
                                    {item.employeeName}<br />
                                    {item.createdByDesignation}<br />
                                    {`${commentDt.date} ${commentDt.monthName} ${commentDt.year} ${commentDt.hour}:${commentDt.minute}:${commentDt.seconds} ${commentDt.amOrpm}`}
                                </span>
                            </div>
                        </div>
                    </div>
                    {
                        commAttachment.length > 0 &&
                        <div className="card-footer no-print">
                            <div className="row">
                                <div className="col-md-12">
                                    <span className="mr-3">Attachment(s)</span>
                                    {
                                        commAttachment.map(function (attachment: any, index2: number) {
                                            const downloadURL = `${process.env.REACT_APP_BASE_URL}etour/${attachment.eTourCode}/${attachment.commentCode}/${attachment.fileName}`.replace('v1/', '');
                                            return (
                                                // <a href={downloadURL} target="_blank" key={index2} className="badge badge-primary mr-1 p-2"><i className="fa fa-arrow-circle-o-down" />{attachment.fileName}</a>
                                                <a href={downloadURL} target="_blank" key={index2} className="badge badge-primary mr-1 p-2"><i className="fa fa-arrow-circle-o-down" /> {attachment.originalFileName}</a>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            )
        });

        if (canReadComments) {
            return renderComments;
        } else {
            return (
                <div className="card comment-file mb-3">
                    <div className="card-body text-center">
                        Comments are only visible to the marked person.
                    </div>
                </div>
            )
        }
    }

    onAddComment = (model: any, attachments: any) => {
        this.setState({ showLoader: true });
         
        addComment(model).then(async (res: any) => {
            this.setState({ showLoader: false });
            if (res) {
                if (res.status === CONSTANT.static.apiStatus.success) {
                    for (let i = 0; i < attachments.length; i++) {
                        const item = attachments[i];
                        const itemModel = { eTourCode: res.result.eTourCode, commentCode: res.result.code, attachment: item }
                        await uploadAttachment(itemModel)
                    }
                    this.props.history.push(CONSTANT.component.userETourList.url);
                } else {
                    alert(res.error);
                }
            }
        });
    }

  
  
  
     onPrint = (e: any) => {
        const mainSection = $('.main-file');
        const reimbursementSection = $('.reimbursement-detail');
        const commentSection = $('.comment-file');
        let html = mainSection.html();
        html += reimbursementSection.html();

        for (let i = 0; i < commentSection.length; i++) {
            html += commentSection[i].innerHTML;
        }

        const style = `
        <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css" integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh" crossorigin="anonymous">
        <style type="text/css">
        body{
            font-size:16px;
        }
        .no-print{visibility: hidden; display:none;}
        .card-body{
            border-bottom: 2px dotted gray;
        }
        
        @page{
            size:A4,
            margin-top: 2cm;
            margin-bottom: 2cm;
            margin-left:6cm;
            margin-right:1.5cm;
        }
        @media print {
            body
            {
                font-size:15.5pt;
            }
            
            .print-btn{
                visibility:hidden;
            }
        }
        </style>
        `;
        const innerHTML = `${style}<button class="print-btn float-right" onclick="window.print()">Print Now</button></div><div class="fluid-container">${html}<br/><button class="print-btn float-right" onclick="window.print()">Print Now</button></div>`;
        let myWindow: any = window.open('', '', 'width=800,height=600');
        myWindow.document.write(innerHTML);
        myWindow.focus();
    }

    toggleAddComment = () => {
        this.setState({ showAddComment: !this.state.showAddComment });
    }

    downloadBills = (bills: any) => {

        for (let i = 0; i < bills.length; i++) {
            const file = bills[i];
            const fileURL = `${process.env.REACT_APP_BASE_URL}reimbursement/${file.eTourCode}/${file.fileName}`.replace('/v1/', '/');
            window.open(fileURL);
        }
    }
     
}

export default ComponentName;